import { Download, Trash2, Copy, Move, Share2, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useItemListContext } from './ItemListProvider';
import { useItemActions } from '@/hooks/useItemActions';

export function SelectionBar() {
  const {
    selectedItemsArray,
    permissions,
    deselectAll,
    selectAll,
    openModal,
    updateIsQuerying,
    onRefresh,
  } = useItemListContext();
  const { downloadItems } = useItemActions({ updateIsQuerying, onRefresh });

  const count = selectedItemsArray.length;
  const hasSelection = count > 0;
  const allResources = selectedItemsArray.every((i) => i.itemtype === 'resource');

  if (!permissions.canEdit && !permissions.canDelete) return null;

  return (
    <div className="flex items-center gap-2 border-b border-border px-1 py-2">
      {!hasSelection ? (
        <Button variant="ghost" size="sm" onClick={selectAll}>
          Select all
        </Button>
      ) : (
        <>
          <span className="text-sm text-muted-foreground">{count} selected</span>
          <Button variant="ghost" size="sm" onClick={deselectAll}>
            <X className="h-4 w-4" />
          </Button>
          <div className="h-4 border-l border-border" />

          {permissions.canDelete && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => openModal('delete', { items: selectedItemsArray })}
            >
              <Trash2 className="h-4 w-4" /> Delete
            </Button>
          )}
          {allResources && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => downloadItems(selectedItemsArray)}
            >
              <Download className="h-4 w-4" /> Download
            </Button>
          )}
          {permissions.canMove && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => openModal('move', { items: selectedItemsArray })}
            >
              <Move className="h-4 w-4" /> Move
            </Button>
          )}
          {permissions.canCopy && allResources && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => openModal('copy', { items: selectedItemsArray })}
            >
              <Copy className="h-4 w-4" /> Copy
            </Button>
          )}
          {permissions.canShare && allResources && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => openModal('shareFile', { items: selectedItemsArray })}
            >
              <Share2 className="h-4 w-4" /> Share
            </Button>
          )}
        </>
      )}
    </div>
  );
}
